import { __assign } from "tslib";
import { AuthActionTypes } from '../actions/auth.actions';
export var initialState = {
    loaded: false,
    options: {}
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case AuthActionTypes.GetClinicIdSuccess: {
            return __assign(__assign({}, state), { options: action.payload.JsonOptions
                    ? JSON.parse(action.payload.JsonOptions)
                    : {} });
        }
        default: {
            return state;
        }
    }
}
export var getClinicOptionsLoaded = function (state) { return state.loaded; };
export var getClinicOptions = function (state) { return state.options; };
export var getVideoCallsEnabled = function (state) {
    return !!state.options.videoCallOptions && !!state.options.videoCallOptions.enabled;
};
export var getVideoCallsPartnerInvite = function (state) {
    return !!state.options.videoCallOptions &&
        !!state.options.videoCallOptions.partnerInvite;
};
export var getLabResultsEnabled = function (state) {
    return !!state.options.labResultOptions && !!state.options.labResultOptions.enabled;
};
export var getMessageStarringEnabled = function (state) {
    return !!state.options.messagingOptions &&
        !!state.options.messagingOptions &&
        !!state.options.messagingOptions.messageStarring;
};
export var getContentEditorEnabled = function (state) {
    return !!state.options.contentEditorOptions &&
        !!state.options.contentEditorOptions.enabled;
};
export var getMessagingV3Enabled = function (state) {
    return !!state.options.messagingOptions &&
        !!state.options.messagingOptions.messagingV3Enabled;
};
export var getPatientFormsEnabled = function (state) {
    return !!state.options.forms &&
        !!state.options.forms.clinicportal &&
        !!state.options.forms.clinicportal.patientforms_enabled;
};
export var getFormDefinitionsEnabled = function (state) {
    return !!state.options.forms &&
        !!state.options.forms.clinicportal &&
        !!state.options.forms.clinicportal.formdefinitions_enabled;
};
